import { Component, StrictMode, type ReactNode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { MsalProvider } from "@azure/msal-react";

import msalInstance from "./authConfig";
import installFetchAuth from "./utils/fetchWithMsal";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";
// import posthog from "posthog-js";

// Create a new router instance
const router = createRouter({ routeTree });

class AppErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }


  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-base-100 text-base-content flex items-center justify-center p-6">
          <div className="max-w-md rounded-box bg-base-200 p-6 shadow-xl text-center space-y-4">
            <h1 className="text-2xl font-bold">Something went wrong</h1>
            <p>The app hit an unexpected error. Reload to recover.</p>
            <button
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Reload app
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
// posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
//   api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
//   capture_exceptions: true,
// });
// posthog.sessionRecording._forceAllowLocalhostNetworkCapture = true;
// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <AppErrorBoundary>
        <MsalProvider instance={msalInstance}>
          <RouterProvider router={router} />
        </MsalProvider>
      </AppErrorBoundary>
    </StrictMode>,
  );
  // Install global fetch auth wrapper (adds Authorization header for backend requests)
  try {
    installFetchAuth();
  } catch {
    // Keep startup resilient if auth fetch wrapper initialization fails.
  }
}
